import React from "react";

import styles from "./styles/Layout.module.scss";

import _ from "lodash";
import { useLocation } from "react-router-dom";
import { useChatContext } from "../context/ChatContext";
import ChatThreads from "./ChatThreads";
import Inbox from "./Inbox";


const MobileLayout: React.FC = () => {
    const location = useLocation();
    const { chatRoom } = useChatContext();

    return (
        <div className={styles.Layout}>
            {!_.isEmpty(chatRoom) ?
                <Inbox
                    isMobile={true}
                /> :
                location.state?.user ? <></> :
                    <ChatThreads />
            }

        </div>
    )
}

export default MobileLayout